<template>
    <div>

        <Dialog :visible.sync="exibirModal" :header="titulo" :modal="true" :style="{ width: '40vw' }" @hide="fechar">
            <div v-if="itens.length > 0">
                <label class="p-text-bold">{{ dados.solicitacao.funcionario.nomecc }}</label>
                <hr>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-6">
                        <label>Data da Solicitação</label>
                        <InputText class="input-readonly" v-model="dados.solicitacao.data" readonly />
                    </div>
                    <div class="p-field p-col-6">
                        <label>Data do Ponto</label>
                        <InputText class="input-readonly" v-model="dados.solicitacao.dataPonto" readonly />
                    </div>
                </div>

                <DataTable :value="itens" :scrollable="true" scrollHeight="190px" :autoLayout="true"
                    class="p-datatable-sm p-datatable-striped">
                    <Column field="dataHora" header="Data Hora">
                        <template #body="slotProps">
                           <label :class="getClassStatus(slotProps.data.acao)">{{ slotProps.data.dataHora }}</label>
                        </template>
                    </Column>
                    <Column field="fonte" header="Fonte">
                        <template #body="slotProps">
                           <label :class="getClassStatus(slotProps.data.acao)">{{ slotProps.data.fonte }}</label>
                        </template>
                    </Column>
                    <Column field="acao" header="Ação">
                        <template #body="slotProps">
                           <label :class="getClassStatus(slotProps.data.acao)">{{ slotProps.data.acao }}</label>
                        </template>
                    </Column>
                    <Column field="justificativa" header="Justificativa">
                        <template #body="slotProps">
                           <label :class="getClassStatus(slotProps.data.acao)">{{ slotProps.data.justificativa }}</label>
                        </template>
                    </Column>
                </DataTable>

                <div class="p-fluid p-formgrid p-grid p-mt-5">
                    <div class="p-field p-col-12 p-md-12">
                        <label class="p-text-bold">Ação</label>
                        <Dropdown v-model="acaoSelecionada" :options="acoes" optionLabel="nome" optionValue="id"
                            placeholder="Selecione" appendTo="body" :disabled="!exibirBotoes"
                            :class="!exibirBotoes ? 'input-readonly' : ''" />
                    </div>
                    <div class="p-field p-col-12 p-md-12" v-if="acaoSelecionada == naoAprovado">
                        <label class="p-text-bold">Observação</label>
                        <Textarea v-model.trim="observacaoNaoAprovado" rows="3" cols="30"
                            :class="!exibirBotoes ? 'input-readonly' : ''" :disabled="!exibirBotoes" />
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="p-d-flex p-jc-end">
                    <div v-if="exibirBotoes">
                        <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary"
                            @click="exibirModal = false" />
                        <Button label="Salvar" icon="pi pi-check" @click="salvar" />
                    </div>
                </div>
            </template>
        </Dialog>

    </div>
</template>
  
<script>
import ControlePontoService from '@/service/ControlePontoService.js';
import { exibirMensagemSis, exibirMensagem, acoesSolicitacoesPendentes, clonar } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    props: {
        callback: Function,
    },
    data() {
        return {
            titulo: 'Solicitação',
            naoAprovado: 'Não Aprovado',
            exibirModal: false,
            observacaoNaoAprovado: '',
            dados: null,
            acaoSelecionada: '',
            acoes: acoesSolicitacoesPendentes,
            exibirBotoes: false,
            itensSolicacao: [],
            itens: []
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        /**
         * 
         * @param {*} dados 
         */
        processar(dados) {
            this.controlePontoService = new ControlePontoService();
            this.dados = dados;
            this.buscarItemSolicitacao();
        },
        /**
        * 
        * @param {*} solicitacao 
        */
        buscarItemSolicitacao() {
            let requisicao = {
                idSolicitacao: this.dados.solicitacao.id,
                idFuncionario: this.dados.solicitacao.funcionario.id,
                dataPonto: this.formartarStrData(this.dados.solicitacao.dataPonto, 'US'),
                usuarioRequisicao: { ...this.getDadosRequisicao() }
            };
            this.controlePontoService.buscarItensSolicitacaoMarcacoesEditadas(requisicao)
                .then(resp => {
                    const solicitacao = this.dados.solicitacao;
                    if (solicitacao.status === 'Pendente' && this.dados.permissaoEditar) {
                        this.exibirBotoes = true;
                    } else {
                        this.acaoSelecionada = solicitacao.status;
                    }
                    if (!solicitacao.observacao) {
                        this.dados.solicitacao.observacao = '';
                    }
                    this.observacaoNaoAprovado = solicitacao.observacao;
                    this.titulo = 'Solicitação | Editar Marcações | Atualizar';
                    this.itensSolicacao = resp.data;
                    this.itensSolicacao.forEach(item => {
                        let descricaoJustificativa = '';
                        if (item.justificativa) {
                            descricaoJustificativa = item.justificativa.descricao;
                        }
                        let acao = 'N/D';
                        const fonte = item.infoCampo3;
                        if ((fonte === 'R' || fonte === 'P') && item.acao === 'DESCONSIDERAR') {
                            acao = 'Descartar';
                        } else if (fonte === 'I') {
                            if (item.acao === 'NOVO') {
                                acao = 'Incluir';
                            } else if (item.acao === 'ATUALIZAR') {
                                acao = 'Atualizar';
                            } else {// EXCLUIR
                                acao = 'Excluir';
                            }
                        }
                        this.itens.push({
                            dataHora: this.formartarStrDataHora(item.infoCampo1, 'BR'),
                            acao: acao,
                            fonte: fonte,
                            justificativa: descricaoJustificativa
                        });
                    });
                    this.exibirModal = true;
                })
                .catch(erro => { exibirMensagem(this, erro) });
        },
        /**
         * 
         */
        salvar() {
            if (this.acaoSelecionada == '') {
                exibirMensagemSis(this, 'Selecione uma ação', true);
                return;
            }
            if (this.acaoSelecionada === this.naoAprovado
                && this.observacaoNaoAprovado === '') {
                exibirMensagemSis(this, 'Informe um texto breve na observação', true);
                return;
            }
            let solicitacao = clonar(this.dados.solicitacao);
            delete solicitacao.funcionario;
            solicitacao.status = this.acaoSelecionada;
            solicitacao.observacao = this.observacaoNaoAprovado;
            solicitacao['usuarioAprovacao'] = this.dados.requisicao.usuarioRequisicao.usuario.nome;
            this.resolverPendenciaAlteracao(solicitacao);
        },
        /**
         * 
         */
        resolverPendenciaAlteracao(solicitacaoAtualizar) {
            const marcacoesREPP = [];
            const marcacoesInseridas = [];
            const idPonto = this.itensSolicacao[0].idReferencia2;
            this.itensSolicacao.forEach(item => {
                const dataHora = item.infoCampo1.split(' ');
                if(item.infoCampo3 === 'R' || item.infoCampo3 === 'P') {
                    marcacoesREPP.push({
                        id: item.idReferencia1,
                        data: dataHora[0],
                        hora: dataHora[1],
                        tipo: item.infoCampo2,
                        fonte: item.infoCampo3,                        
                        descartado: item.acao === 'DESCONSIDERAR' ? true : false,
                        nova: false,
                        justificativa: item.justificativa,
                    });
                } else {// I
                    marcacoesInseridas.push({
                        id: item.idReferencia1,
                        data: dataHora[0],
                        hora: dataHora[1],
                        tipo: item.infoCampo2,
                        fonte: item.infoCampo3,                        
                        descartado: item.acao === 'EXCLUIR' ? true : false,
                        nova: item.acao === 'NOVO' ? true : false,
                        justificativa: item.justificativa,
                    });
                }
            });
            const novaRequisicao = {
                cnpj: this.dados.requisicao.cnpj,
                solicitacao: solicitacaoAtualizar,
                mes: this.dados.requisicao.mes,
                ano: this.dados.requisicao.ano,
                idPonto: idPonto,
                marcacoesREPP: marcacoesREPP,
                marcacoesInseridas: marcacoesInseridas,
                funcionario: this.dados.solicitacao.funcionario,
                usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
            }
            this.controlePontoService.resolverEditarMarcacoesAlterarPendente(novaRequisicao)
                .then(resp => {
                    this.fechar();
                    exibirMensagem(this, resp);
                    this.callback(solicitacaoAtualizar);
                })
                .catch(erro => { exibirMensagem(this, erro) });
        },
        getClassStatus(acao) {
            if(acao === 'Incluir' || acao === 'Atualizar') {
                return 'ik-text-primary p-text-bold';
            }
            if(acao === 'Descartar' || acao === 'Excluir') {
                return 'ik-text-danger p-text-bold';
            }
            return '';
        },
        /**
         * 
         * @param {*} strData 
         * @param {*} formato 
         */
        formartarStrData(strData, formato) {
            if (formato == 'BR') {
                let partes = strData.split('-');
                return partes[2] + '/' + partes[1] + '/' + partes[0];
            }
            let partes = strData.split('/');
            return partes[2] + '-' + partes[1] + '-' + partes[0];
        },
        /**
         * 
         * @param {*} strData 
         * @param {*} formato 
         */
        formartarStrDataHora(strData, formato) {
            if (formato == 'BR') {
                let dataHora = strData.split(' ');
                let partes = dataHora[0].split('-');
                return partes[2] + '/' + partes[1] + '/' + partes[0] + ' ' + dataHora[1];
            }
            let dataHora = strData.split(' ');
            let partes = dataHora[0].split('/');
            return partes[2] + '-' + partes[1] + '-' + partes[0] + ' ' + dataHora[1];
        },
        /**
         * 
         */
        fechar() {
            this.exibirModal = false;
            this.itemPendente = null;
            this.observacaoNaoAprovado = '';
            this.dados = null;
            this.acaoSelecionada = '';
            this.exibirBotoes = false;
            this.controlePontoService = null;
            this.titulo = 'Solicitação';
            this.itens = [];
            this.itensSolicacao = [];
        }
    }
}
</script>
  
<style scoped>
.input-readonly {
    background-color: #F2F2F2;
}
</style>